let func = (top, page) => {
  let path = page.path
  let arr = path.split('/')
  let name = top == 'admin' ? 'admin' : '', import_path = '', last = ''
  let iter = (el) => {
    name += el
    if (page.card == null || page.card || el != '' && !el.card) {
      if (last != '')
        import_path += '/' + last
      last = el
    }
  }

  for(let i in arr) {
    if (arr[i] == '') continue
    if (arr[i][0] != ':') {
      iter(arr[i])
    } else iter('')
  }

  if (import_path == '' && last == '') {
    import_path = '/Main'
  } else {
    if (last == '') {
      last = 'card'
    } else if (page.card) {
      import_path += '/' + last
      last = 'card'
    }
    import_path += '/' + last[0].toUpperCase() + last.substring(1)
  }
  let obj = {
    path,
    name,
    meta: {
      label: page.title,
      title: page.title
    },
    component: () => import('@/pages/' + top + import_path)
  }
  if (page.free)
    obj.meta['free'] = true
  if (page.props)
    obj['props'] = page.props
  return obj
}

export const pageRouter = (pages) => {
  let arr = []
  for(let page in pages) {
    let children = []
    for(let inner of pages[page]) {
      children.push(func(page, inner))
    }

    let container = page == 'user' ? 'guest' : page;
  
    arr.push({
      path: page == 'admin' ? '/admin' : '/',
      name: page,
      component: () => import('@/layouts/' + container[0].toUpperCase() + container.substring(1) + 'Container'),
      children: children
    })
  }
  return arr;
}